module.exports = __webpack_public_path__ + "img/comm-server.bb3c7ac0.svg";